module.exports = __webpack_public_path__ + "static/media/11-1.6ec2e07e.jpg";